
import BannerGeneral from "../components/BannerGeneral";
import BlockAcademicOffer from "../components/BlockAcademicOffer";
import DataFetcherTemplate from "../hooks/fetchTemplate";
import DataDisplayOtrasFormas from "../components/DataDisplayOtrasFormas";
import { NavLink } from "react-router-dom";
import Breadcumbs from "../components/Breadcumbs";

function Oferta() {
  return (
    <>
      <div className="margin ">
        <Breadcumbs
          content={
            <>
              <NavLink to="/oferta">Oferta académica</NavLink>
            </>
          }
        ></Breadcumbs>
      </div>

      <BlockAcademicOffer></BlockAcademicOffer>

    <div className="margin">
        <DataFetcherTemplate url="https://tec.utpl.edu.ec/otras_formas_home">
          {(data) => <DataDisplayOtrasFormas data={data} />}
        </DataFetcherTemplate>
      </div>


      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Oferta;
